import { render } from "./PetVetConnection.vue?vue&type=template&id=ca0cd8de&scoped=true"
import script from "./PetVetConnection.vue?vue&type=script&lang=js"
export * from "./PetVetConnection.vue?vue&type=script&lang=js"

import "./PetVetConnection.vue?vue&type=style&index=0&id=ca0cd8de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca0cd8de"]])

export default __exports__